import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
// import {getPersonalDetailsLocationAPi} from "../../API/API";
import {getPersonalDetailsLocationApi} from "../../API/API";

function* getPersonalDetailsLocationSaga(action) {
  
    try {
        const { location, paramName } = action.payload;
        const response = yield call(() => getPersonalDetailsLocationApi(location, paramName));
        yield put({ type: types.GET_PERSONALDETAILSLOCATION_SUCCESS, payload: response.data });
  
    } catch (error) {
        yield put({ type: types.GET_PERSONALDETAILSLOCATION_FAILURE, error });
    }
}

export function* watchGetPersonalDetailsLocationSaga() {
    yield takeEvery(types.GET_PERSONALDETAILSLOCATION_REQUESTED, getPersonalDetailsLocationSaga);
}